import { z } from 'zod';
// Disposition schema
export const dispositionSchema = z.object({
    code: z.string().min(1),
    description: z.string(),
    canCallback: z.boolean(),
    isEditable: z.boolean().optional(),
    isDeletable: z.boolean().optional(),
});
export const dispositionConfigSchema = z.object({
    prompt: z.string(),
    codes: z.array(z.string()),
});
// Agent schema
export const agentSchema = z.object({
    id: z.string(), // alt_key from engine_agents
    agent_name: z.string(),
    voice: z.string(), // voice alt_key
    llm_id: z.number().optional(),
    percentage: z.number().min(0).max(100),
    experiment: z.string().default(''),
    vapiAgentId: z.string().optional(),
});
// Metric schema
export const metricConfigSchema = z.object({
    id: z.string(),
    name: z.string(),
    filter: z.enum(['all_calls', 'successful_calls', 'over_30_seconds']),
    type: z.enum(['includes_phrase', 'llm_eval']),
    config: z.object({
        phrases: z.string().optional(),
        prompt: z.string().optional(),
    }),
});
// Telephony types
export const telephonySchema = z.enum(['custom', 'twilio', 'asterisk']).nullable();
export const directionSchema = z.enum(['inbound', 'outbound']);
// Create campaign schema
export const createCampaignSchema = z.object({
    name: z.string().min(1).max(100),
    direction: directionSchema.default('outbound'),
    language: z.string().default('en'),
    telephony: telephonySchema.default(null),
});
// Full campaign save schema (for creating/updating with all data)
export const saveCampaignSchema = z.object({
    id: z.number(), // 0 for new campaign
    name: z.string().min(1).max(100),
    direction: directionSchema,
    language: z.string(),
    country: z.string().length(2).nullable().optional(),
    telephony: telephonySchema,
    agents: z.array(agentSchema),
    dispositions: z.array(dispositionSchema),
    metrics: z.array(z.any()), // Backend format after conversion
});
// Update campaign schema
export const updateCampaignSchema = z.object({
    name: z.string().min(1).max(100).optional(),
    direction: directionSchema.optional(),
    language: z.string().optional(),
    telephony: telephonySchema.optional(),
    dispo_config: dispositionConfigSchema.nullable().optional(),
});
export const patchCampaignSchema = updateCampaignSchema.partial();
